import { html, rune, View } from 'rune-ts';
import klass from './CaseSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { CaseCard } from './CaseCard';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { map, pipe, toArray } from '@fxts/core';

export class CaseSection extends View {
  pcSwiper?: Swiper;
  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    return html`
      <section class="${klass.case}">
        <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
          ${html.preventEscape(ET('mps2::landing::popup_store::case_title'))}
        </div>
        <div class="${klass.swiper} swiper case_swiper">
          <div class="${klass.swiper_wrapper} swiper-wrapper ">${this._renderCardList()}</div>
          <div class="${klass.pagination} swiper-pagination"></div>
        </div>
      </section>
    `;
  }

  override onRender() {
    this.pcSwiper = this._onLoadCaseSwiperPc();
  }

  private _onLoadCaseSwiperPc() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    return new Swiper('.case_swiper', {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: is_mobile ? 16 : 32,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
        progressbarFillClass: `${klass.progressbar_fill} swiper-pagination-progressbar-fill`,
      },
      on: {
        init: function (swiper) {
          swiper.el.classList.add(klass.visible);
        },
      },
      grabCursor: true,
    });
  }

  private _renderCardList() {
    return pipe(
      ['a', 'b', 'c', 'd', 'e'] as const,
      map((caseLabel) => new CaseCard({ caseLabel })),
      map((CaseCard) => html`<div class="swiper-slide ${klass.slide}">${CaseCard}</div>`),
      toArray,
    );
  }
}
